import { render, staticRenderFns } from "./AdminNavigationLinks.vue?vue&type=template&id=27198f9e&lang=pug&"
import script from "./AdminNavigationLinks.vue?vue&type=script&lang=js&"
export * from "./AdminNavigationLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports